import type { AxiosError } from "axios"
import { isAxiosError } from "axios"
import { toast } from "react-hot-toast"
import { showValidationErrorToast, showValidationErrorToastDev } from "@/features/errors/toasts/dev-toasts.tsx"
import { isDevelopment } from "@/shared/config/environment.ts"

export function customThrowOnError(error: Error) {
  if (isAxiosError(error)) {
    if (error.status) {
      handleToastError(error)
      return false
    }
  }
  return true
}

// export const handleQueryError = (error: unknown) => {
//   if (isAxiosError(error)) {
//     switch (error.status) {
//       case 404:
//         router.navigate("/not-found")
//         break
//       case 403:
//         router.navigate("/forbidden-error")
//         break
//       case 502:
//         router.navigate("/bad-gateway-error")
//         break
//       case 500:
//         router.navigate("/server-error")
//         break
//     }
//   }
// }

// interface IErrorSet {
//   current: Set<string>
// }

// const shownErrors: IErrorSet = { current: new Set() }

export const handleToastError = (error: AxiosError) => {
  const errorUrl = error.config?.url
  const errorKey = `${error.status}-${errorUrl}`

  console.log(errorUrl, error)
  // if (!shownErrors.current.has(errorKey)) {
  switch (error.status) {
    case 400:
      if (!isDevelopment) showValidationErrorToastDev(error)
      else showValidationErrorToast(error)

      // shownErrors.current.add(errorKey)
      break
    case 404:
      toast.error(<span>{errorUrl}</span>, {
        className: "!min-w-fit !max-w-none",
        style: {
          width: "auto",
          whiteSpace: "nowrap",
          maxWidth: "none"
        }
      })
      // shownErrors.current.add(errorKey)
      break
  }
  // }
}
